<template>
    <ul>
        <li v-if="options.numPlayers">{{ $t('gameOptions.nPlayers', {n: options.numPlayers}) }}</li>
        <li v-if="options.anon == true">{{ $t('common.anonymous') }}</li>
        <li v-if="options.prelude">Prelude</li>
        <li v-if="options.venus">Venus</li>
        <li v-if="options.colonies">{{ $t('gameOptions.colonies') }}</li>
        <li v-if="options.turmoil">Turmoil
            <span v-if="options.turmoilA">
            {{ options.turmoilAV == "Chairman" ? ' (' + $t('gameOptions.chairmanChooses') + ')' : ' (' + $t('gameOptions.randomAgendas') + ')'}}
            </span>
        </li>
        <li v-if="options.trajectory">Trajectory</li>
        <li v-if="options.hasOwnProperty('ptvis') && !options.ptvis">{{ $t('gameOptions.hiddenPoints') }}</li>
        <li v-if="options.moon" class="red">Moon</li>
        <li v-if="options.ares" class="red">Ares</li>
        <li v-if="options.fanMade" class="red">Fan Made corps</li>
    </ul>
</template>

<script>
export default {
  name: "GameOptions",
  props: ['options']
};
</script>

<style scoped>
    ul { 
        padding-left: 0;
    }

    .red {
        color: red;
    }
</style>